import React from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  CircularProgress,
  Alert,
  Card,
  CardContent,
  Divider,
} from '@mui/material';
import { PlayArrow } from '@mui/icons-material';
import { useYoutubeOptimizer } from '../../hooks/useYoutubeOptimizer';

const AdminPage: React.FC = () => {
  const { launchOptimizer, result, isLoading, error } = useYoutubeOptimizer();

  const handleLaunchOptimizer = async () => {
    await launchOptimizer();
  };

  const renderResult = () => {
    if (!result) return null;

    return (
      <Card sx={{ mt: 3, maxWidth: '100%' }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Optimization Result
          </Typography>
          <Divider sx={{ mb: 2 }} />

          {Object.keys(result.ok).length > 0 && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle1" color="success.main" gutterBottom>
                ✅ Successful Operations
              </Typography>
              {Object.entries(result.ok).map(([key, value]) => (
                <Box key={key} sx={{ ml: 2, mb: 1 }}>
                  <Typography variant="body2" fontWeight="bold">
                    {key}:
                  </Typography>
                  {Object.entries(value).map(([subKey, subValue]) => (
                    <Box key={subKey} sx={{ ml: 2 }}>
                      <Typography variant="body2" component="span">
                        {subKey}:{' '}
                      </Typography>
                      <Typography variant="body2" component="span" color="primary">
                        {subValue}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ))}
            </Box>
          )}

          {Object.keys(result.ko).length > 0 && (
            <Box>
              <Typography variant="subtitle1" color="error" gutterBottom>
                ❌ Failed Operations
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {Object.keys(result.ko).length} operation(s) failed
              </Typography>
            </Box>
          )}
        </CardContent>
      </Card>
    );
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Admin Dashboard
      </Typography>

      <Paper sx={{ p: 3, maxWidth: 600 }}>
        <Typography variant="h6" gutterBottom>
          YouTube Performance Optimizer
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Launch the YouTube performance optimizer to check and optimize your YouTube campaigns.
        </Typography>

        <Button
          variant="contained"
          startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <PlayArrow />}
          onClick={handleLaunchOptimizer}
          disabled={isLoading}
          sx={{ mb: 2 }}
        >
          {isLoading ? 'Launching...' : 'Launch YouTube Performance Optimizer'}
        </Button>

        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}

        {renderResult()}
      </Paper>
    </Box>
  );
};

export default AdminPage;
